module.exports = __webpack_public_path__ + "img/Weapon_56.55424ca5.png";